export const SET_TEAM_LIST = 'BONTI:SET_TEAM_LIST'
export const SET_TEAM = 'BONTI:SET_TEAM'